import cookiesPolicy from './web/CookiesPolicy/index';
// RO mutace pouziva CookieBota
// SK, PL, HR a SI prozatim nepublikovat
// cookie lista bude jen na SSH, KV a AEU
if (
	window.projectConfig.webId === 'ssh' ||
	window.projectConfig.webId === 'kvido' ||
	window.projectConfig.webId === 'aeu' ||
	(window.projectConfig.webId === 'default' &&  window.projectConfig.lang === 'sk')
) {
	cookiesPolicy({
		lang:     window.projectConfig.lang,
		messages: {
			'cs': {
				text:     'Tento web používá k&nbsp;poskytování funkcí sociálních médií a&nbsp;analýze návštěvnosti soubory cookies. Používáním tohoto webu souhlasíte s&nbsp;ukládáním a&nbsp;používáním souborů cookies.',
			},
			'pl': {
				text:     'Ta strona wykorzystuje pliki cookies w celu zapewnienia prawidłowego jej funkcjonowania, zapamiętywania danych logowania i innych informacji, które zwiększają wygodę korzystania ze strony, korzystania z narzędzi analitycznych oraz działań marketingowych. Szczegóły znajdziesz w Polityce prywatności i Polityce cookies. Jeśli wyrażasz zgodę na wykorzystywanie plików cookies kliknij „Rozumiem i akceptuję”. Jeśli nie chcesz, aby pliki cookies były przechowywane, możesz w każdej chwili zmienić ustawienia swojej przeglądarki. Pamiętaj, że po zaakceptowaniu ciasteczek możesz w dowolnym momencie zmienić zdanie.',
			},
			'sk': {
				text:     'Táto webová lokalita používa na poskytovanie funkcií sociálnych médií návštevnosti súbory cookies. Používaním tejto webovej lokality súhlasíte s ukladaním a používaním súborov cookies.',
			},
			// 'ro': {
			// 	text:     'Acest site utilizeaza cookie-uri. Te rog sa navighezi in continuare dupa ce ti-ai exprimat consimtamantul.',
			// 	link:     '/ro/politica-de-confidentialitate/politica-pentru-cookie-uri',
			// },
			'hr': {
				text:     'Ova web stranica koristi kolačiće, koji su potrebni za funkcioniranje nekih njenih dijelova.',
				// link:     '/hr/kolacici',
			},
			'si': {
				text:     'Ta spletna stran uporablja piškotke, ki so potrebni za delovanje nekaterih njenih delov.',
				// link:     '/si/piskotki',
			},
		},
	});
}

require('./eshop');
var $ = require('jquery');
//shimované pluginy většinou nemají export, většinou extendují jQuery object
require('fg-frontend/ramjet/liveValidation');
require('fg-frontend/ramjet/partialUpdate');
var TargetBlankAutoTitle = require('fg-frontend/plugins/required/targetBlankAutoTitle');
var PhoneLinkActivation = require('fg-frontend/plugins/required/phoneLinkActivation');
import {WysiwygSlider} from './web/WysiwygSlider';
require('./web/highslide-settings');
var Preloader = require('fg-frontend/plugins/universal-preloader/preloader');
var EdeeshopPopup = require('fg-frontend/plugins/edeeshop-popup/EdeeshopPopup');
require('bootstrap/collapse');
require('bootstrap/carousel');
window.videojs = require('video.js/dist/video');
//require('jquery-ui/datepicker');
//require('jquery-ui/i18n/datepicker-cs');
//require('fg-frontend/third/jquery-ui/datetimePicker/timepicker');
//require('fg-frontend/third/jquery-ui/datetimePicker/localization/timepicker-cs');

require('fg-frontend/plugins/jquery.social-share');
require('fg-frontend/plugins/jquery.universal-pagination');
require('./web/jquery.gm');
require('./web/select2');

//export to window
window.$ = $;
window.jQuery = $;
web.googlemaps = window.web.googlemaps || {};

var nav                 = $('.js_headerNav'),
    menuToggle          = $('.burger'),
    menuSecondaryToggle = $('.js_secondaryMenuToggle'),
    langSwitchToggle    = $('.js_header-lang-switch-toggle');

menuToggle.on('click', function () {
	nav.toggleClass('active');
	menuToggle.toggleClass('active');
	return false;
});

menuSecondaryToggle.on('click', function () {
	$(this).toggleClass('active');
	$(this).next('ul').toggleClass('active');
	return false;
});

langSwitchToggle.on('click', function () {
	$(this).toggleClass('active');
	$(this).next('ul').toggleClass('active');
	return false;
});

(function () {
	function bind() {
		$('.news-filter__sort,.js_select-design').select2({
			minimumResultsForSearch: -1,
			dropdownAutoWidth:       true,
			width:                   'auto',
			templateResult:          function (data, container) {
				if ( data.element ) {
					if ( data.element.parentElement.id == 'kvidoSelect' ) {
						$(container).addClass($(data.element).attr('class'));
					}
				}
				return data.text;
			},
		});
	}

	bind();
	jQuery('body').on('afterContentsReplaced', bind);
})();

$('.js_wyswiwygSlider-wrapper').each(function (i, el) {
	var inst = new WysiwygSlider($(el));
	inst.init();
});

$('.js_downloads-form').each(function (i, elm) {
	var $elm = $(elm);
	var $select = $($elm.find('.js_downloads-select'));
	var $desc = $($elm.find('.js_downloads-description'));

	$elm.on('submit', function (e) {
		window.location.href = $select.val();
		e.preventDefault();
	});

	$elm.on('change', function (e) {
		$desc.text($elm.find('option:selected').data('addText'));
		e.preventDefault();
	});
	$desc.text($elm.find('option:selected').data('addText'));

});

$('.js_toggle-fulltext').on('click', function (e) {
	var $formSearch = $('.form-search');
	e.preventDefault();
	$(this).toggleClass('active');
	if ( $formSearch.hasClass('hidden') ) {
		$formSearch.removeClass('hidden').hide();
	}
	$formSearch.slideToggle(200);

	if ( langSwitchToggle.hasClass('active') ) {
		langSwitchToggle.removeClass('active');
		langSwitchToggle.next('ul').removeClass('active');
	}

	$formSearch.find('#query').focus();
});

//Product gallery support
(function () {
	$.fn.nextOrFirst = function (selector) {
		var next = this.next(selector);
		return (next.length) ? next : this.prevAll(selector).last();
	};

	$.fn.prevOrLast = function (selector) {
		var prev = this.prev(selector);
		return (prev.length) ? prev : this.nextAll(selector).last();
	};

	function getActiveItem($items, jsActiveClass) {
		var ret = null;
		$items.each(function (e, item) {
			if ( $(item).hasClass(jsActiveClass) ) {
				ret = $(item);
			}
		});

		return ret;
	}

	$('body').on('click', '.js_productGallery-mainImg', function (e) {
		e.preventDefault();
		var jsActiveClass = 'js_active';
		var $items = $('.js_productGallery-item');
		getActiveItem($items, jsActiveClass).find('a').click();
	});

	$('body').on('click', '.js_productGallery-button', function (e) {
		e.preventDefault();
		var $elm = $(this);
		var direction = $elm.data('dir');
		var $mainImg = $('.js_productGallery-mainImg');
		var $items = $('.js_productGallery-item');
		var jsActiveClass = 'js_active';
		var cssActiveClass = 'active';

		function getItemAfterActive() {
			return getActiveItem($items, jsActiveClass).nextOrFirst();
		}

		function getItemBeforeActive() {
			return getActiveItem($items, jsActiveClass).prevOrLast();
		}

		function removeActiveClass($elm) {
			$elm.removeClass(jsActiveClass);
			$elm.find('a').removeClass(cssActiveClass);
		}

		function addActiveClass($elm) {
			$elm.addClass(jsActiveClass);
			$elm.find('a').addClass(cssActiveClass);
		}

		var activeElm = getActiveItem($items, jsActiveClass);
		var nextElm = getItemAfterActive();
		var prevElm = getItemBeforeActive();

		removeActiveClass($(activeElm));

		if ( direction == 'prev' ) {
			addActiveClass($(prevElm));
			$mainImg.attr('href', $(prevElm).find('a').attr('href'));
			$mainImg.find('img').attr('src', $(prevElm).data('mainThumbSrc'));
		}

		if ( direction == 'next' ) {
			addActiveClass($(nextElm));
			$mainImg.attr('href', $(nextElm).find('a').attr('href'));
			$mainImg.find('img').attr('src', $(nextElm).data('mainThumbSrc'));
		}

	});
})();

//Add video from wysiwyg
$('video').each(function () {
	$(this).addClass('video-js vjs-default-skin');
	var elm = this;
	videojs(elm, { 'fluid': true }, function () {
		// This is functionally the same as the previous example.
	});
});

// universal preloader
var universalPreloader = new Preloader();

/* TABS */
var tabsNav           = $('.js_tabsNav'),
	navLinks          = tabsNav.find('li'),
	tabsContainer     = $('.js_tabsContainer'),
	productsContainer = tabsContainer.find('.tab-products'),
	articlesContainer = tabsContainer.find('.tab-articles');

//manipulate on click

navLinks.on('click', function () {
	//sort how navigation displays
	navLinks.each(function () {
		$(this).removeClass('active');
	});
	$(this).toggleClass('active');

	if ( $(this).hasClass('js_tabsProducts') ) {
		productsContainer.addClass('active');
	} else {
		productsContainer.removeClass('active');
	}

	if ( $(this).hasClass('js_tabsArticles') ) {
		articlesContainer.addClass('active');
	} else {
		articlesContainer.removeClass('active');
	}
});

// KVIDO centered submenu
if ( window.innerWidth >= 1240 ) {
	$('.styles-kv .menu-secondary').each(function () {
		$(this).css({
			'left':        '50%',
			'margin-left': $(this).width() / 2 * -1 + 'px',
		});
	});
}

// detect apple device
var deviceMac = /(MacIntel|MacPPC|Mac68K|Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
var deviceIOS = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
if ( deviceMac || deviceIOS ) {
	document.getElementsByTagName('body')[ 0 ].classList.add('apple-device');
}

/**
 * Edeeshop Popup init
 */
window.edeeshopPopup = new EdeeshopPopup();

/**
 * Promění definovaný selektor (span.phone-number je default, z této definice je možné smazat) v odkazy s telefonním číslem.
 * Pouze na mobilních telefonech. Automaticky se mění i po přidání do DOMu. Pokud z nějakého důvodu nefunguje,
 * je možné pořešit pomocí phoneLink.getRelevantElements()
 */
var phoneLink = new PhoneLinkActivation(document.body, {
	selector:      'span.phone-number',		// vymezit selektor, kde chceme použít transformaci čísla na odkaz
	linkClassName: 'phone-number',		// třída, která bude vložena na výsledný odkaz (kvůli případnému stylování)
	domChange:     true,						// flag, zda chceme měnit čísla on the fly i po změně DOMu.
	// Pokud ne, phoneLink.getRelevantElements()
});
// window.phoneLink = phoneLink;		// toto není nutné zapínat, pokud nepotřebujeme manuálně volat změnu

/**
 * Pokud máte na stránce anchor s target="blank" atributem, který nemá vyplněný title, nasadí se na něj
 * automaticky titulek ve smyslu "Otevře se v novém okně" dle langu stránky (atribut html lang).
 * Texty jsou definované ve třídě TargetBlankAutoTitle. Lze je definovat ručně při incicalizaci
 * např:  $("body").targetBlankAutoTitle({labels: {cs: "Lorem ipsum", sk: "Dolor sit"}});
 *
 * Pro weby mimo standardní kolekci jazyků (en, de, sk, cz) doporučuji překlad korekturovat.
 * Byl pouze automaticky přeložen.
 *
 * Korekturované překlady můžete dávat do issue https://ep.fg.cz/issues/60227
 *
 * Zkratky jazyků jsou z ISO 639-1 normy
 */
window.targetBlankAutoTitle = new TargetBlankAutoTitle();

/* google map */
$.googlemap.setDefaults({
	mapOptions: {
		scrollwheel:       true,
		mapTypeControl:    false,
		streetViewControl: false,
	},
});

/**
 * automatické ošetření sdílecích tlačítek.
 *
 * HTML markup
 * <div class="js_social-share">
 *     <a href="javascript:void(0)" data-social-network="twitter"> Sdílet na Twitteru</a>
 * </div>
 *
 * data-social-network: facebook | twitter | gplus | linkedin | pinterest
 *
 * na odkaz možno dodat data:
 * data-share-title - vlastní titulek (pokud má být různý od document.title)
 * data-url-share - vlastní URL sdíleného článku, pokud se má lišit od document.URL
 * data-pinterest-image - podstrčení obrázku, který má být připinnován na pinterest
 */
$('.js_social-share a[data-social-network]').socialShare();

// Reset parameters button in navigation
var removeFilterBtn = $('#removeParameterFilterBtn'),
    filterItemInput = $('.filter-item > input[type=checkbox]');

// Check for state and adjust class for button. Don't forget, values get stored in cookies...
filterItemInput.each(function () {
	if ( filterItemInput.is(':checked') ) {
		removeFilterBtn.addClass('active');
	} else {
		removeFilterBtn.removeClass('active');
	}
});

// Display button when any of the checkboxes are checked
filterItemInput.on('click', function () {
	//console.log('hey hou');
	filterItemInput.each(function () {
		if ( filterItemInput.is(':checked') ) {
			removeFilterBtn.addClass('active');
		} else {
			removeFilterBtn.removeClass('active');
		}
	});
});

// Remove filter from all checkboxes
removeFilterBtn.on('click', function () {
	// check each input and click on checked inputs to unfiler results
	filterItemInput.each(function () {
		if ( $(this).is(':checked') ) {
			$(this).click();
		}
	});
	removeFilterBtn.removeClass('active');
});

/* Kvido voucher codes show/hide */
var kvidoGiftsSelect = $('.js_kvidoGiftsSelect');
$('#' + kvidoGiftsSelect.val()).addClass('active');

kvidoGiftsSelect.change(function () {
	$('.kvido-gifts__gift').removeClass('active');
	$('#' + $(this).val()).addClass('active');
});

/* YouTube RWD */
$('.page-container iframe[src*="youtube"]').wrap('<div class="video-box ratio ratio_16_9">');

/**
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, function (index, f) {
	$(f);
});




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web.js